import React, { Component } from 'react'
import styles from './styles/sidebox.scss'

export default class SideBox extends Component {
  render() {
    const { children } = this.props

    return <section className={styles.sidebox}>{children}</section>
  }
}



// WEBPACK FOOTER //
// ./src/components/SideBox.js